import { render, staticRenderFns } from "./ConnectionApiTestComponent.vue?vue&type=template&id=36e147b0&scoped=true&"
import script from "./ConnectionApiTestComponent.vue?vue&type=script&lang=js&"
export * from "./ConnectionApiTestComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e147b0",
  null
  
)

export default component.exports